import PagesTabs from "./tabs";
import { SECURITY_SERVICES_CONSTANTS } from "@/components/header/header.constants";

const SecurityServicesTabs = () => {
  return <PagesTabs props={SECURITY_SERVICES_CONSTANTS} />;
};

export default SecurityServicesTabs;
